const PREFIX = "CONTEXT_";
export const SWITCH = `${PREFIX}SWITCH`;
export const SET_REFRESHING = `${PREFIX}SET_REFRESHING`;